import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import i18n from '../../../i18n';

import scss from './SupportSection.module.scss';

function LanguagesSwitch() {
  const {
    i18n: { language },
  } = useTranslation();

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
    window.localStorage.setItem('LANG', lang);
  };

  return (
    <div className={scss.languagesSwitch}>
      <button
        onClick={() => handleLanguageChange('en')}
        className={clsx(scss.languageButton, language === 'en' && scss.languageButtonSelected)}>
        <span>EN</span>
      </button>
      <button
        onClick={() => handleLanguageChange('de')}
        className={clsx(scss.languageButton, language === 'de' && scss.languageButtonSelected)}>
        <span>DE</span>
      </button>
    </div>
  );
}

export default LanguagesSwitch;
